<script>
import { PackageIcon, GridIcon, SettingsIcon } from 'vue-feather-icons'
export default {
  components: {
    PackageIcon,
    GridIcon,
    SettingsIcon
  }
}
</script>

<template lang="pug">
.navigation
  button.btn.navigation__button(
    type="button"
    :class="{ 'text-primary': $route.path == '/support' }"
    v-ea-click="() => {$router.push('/support')}"
  )
    package-icon.mb-3(size="1.5x")
    .fs-1-6rem {{ $t('support.navigation.deliveryRequestsTab') }}

  button.btn.navigation__button(
    type="button"
    :class="{ 'text-primary': $route.path == '/support/collectomate' }"
    v-ea-click="() => {$router.push('/support/collectomate')}"
  )
    grid-icon.mb-3(size="1.5x")
    .fs-1-6rem {{ $t('support.navigation.collectomateTab') }}

  button.btn.navigation__button(
    type="button"
    :class="{ 'text-primary': $route.path == '/support/settings' }"
    v-ea-click="() => {$router.push('/support/settings')}"
  )
    settings-icon.mb-3(size="1.5x")
    .fs-1-6rem {{ $t('support.navigation.settingsTab') }}
</template>

<style scoped lang="scss">
@import '@/assets/styles/variables.scss';

.navigation {
  width: 100vw;
  height: 12vh;
  border-top: 1px solid $gray-lighter;
  display: flex;
  z-index: 1;
  background: #fff;
  position: fixed;
  bottom: 0px;

  .navigation__button {
    flex: 1;
    padding: 0px;
    color: $gray;
    outline: none;
    box-shadow: none;
  }
}
</style>
